module.exports = __webpack_public_path__ + "img/memo.1b011b31.svg";